module.exports = __webpack_public_path__ + "img/3.d0c889e3.jpg";